import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';

import SubmitButton from 'components/ui/buttons/SubmitButton';
import AuthApi from 'api/auth';

const EmailForm = ({ show, setEmail }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const signin_email = urlParams.get('signin_email');

  const { t } = useTranslation();

  const [authenticating, setAuthenticating] = useState(false);
  const [message, setMessage] = useState({});

  useEffect(() => {
    if (signin_email) {
      document.querySelector('#continue-btn').click();
    }
  }, [signin_email]);

  if (!show) {
    return null;
  }

  const onSubmit = async e => {
    e.preventDefault();

    const email = document.getElementById('inputEmail').value;

    try {
      setAuthenticating(true);
      await AuthApi.validateEmail(email);
      setEmail(email);
    } catch (error) {
      const { status } = error.response || error;
      if (status === 401) {
        setMessage({ type: 'error', description: t('messages.invalid_user') });
      } else {
        setMessage({ type: 'error', description: t('messages.unexpected_error') });
      }
    } finally {
      setAuthenticating(false);
    }
  };

  const renderMessage = () => {
    if (!message.type) {
      return null;
    }
    return (
      <div className="alert alert-danger mt-4" role="alert">
        {message.description}
      </div>
    );
  };

  return (
    <form className="mt-4" id="signin-form-email" onSubmit={onSubmit}>
      <div className="form-group">
        <label htmlFor="inputEmail">{t('columns.email')}:</label>
        <input
          type="email"
          className="form-control"
          autoFocus
          disabled={authenticating}
          defaultValue={signin_email}
          id="inputEmail"
          placeholder={t('signin.form.email_input.placeholder')}
          required
        />
      </div>

      {renderMessage()}

      <div className="mt-4">
        <div>
          <SubmitButton loading={authenticating} className="btn btn-primary shadow form-control" id="continue-btn" tkey="keys.continue" />
        </div>

        <div className="form-group mt-4 text-center">
          Ainda não é cadastrado? <a href="https://youfy.com.br/signup">Crie uma conta</a>
        </div>
      </div>
    </form>
  );
};

export default EmailForm;
